<template>
  <div
    class="rent-bd tb"
    v-if="funcView.receive_refund_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 操作项 -->
        <el-radio-group
          v-model="formSearch.dataType"
          @change="onTabChange"
        >
          <el-radio-button
            :label="item.value"
            v-for="(item, index) in dataType"
            :key="index"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>
        <el-form-item
          v-if="funcView.receive_refund_export"
          style="float: right; margin-right: 0"
        >
          <el-dropdown>
            <el-dropdown-menu>
              <el-button
                class="table-set"
                style="vertical-align: top"
                @click.native="exportTable('billRefundExport', formSearch)"
              ><i class="icon icon-daochu"></i></el-button>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :style="{ marginRight: !funcView.receive_refund_export ? '0' : '' }"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('fms_receive_refund.htddbh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        :key="formSearch.dataType"
        index
        height="100%"
        v-model="tableSelect"
        :data="tableList"
        tableCode="receiveRefund"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
        :filterArr="formSearch.dataType == 1 ? ['finalPaymentTime', 'billInvoiceState'] : []"
        :slots="['totalTerm', 'action']"
      >
        <template
          slot="totalTerm"
          slot-scope="scope"
        >
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <div v-if="funcView.receive_refund_check_collection && formSearch.dataType == 2">
            <el-button
              type="text"
              size="mini"
              @click="onCheckCollectionRecords(scope.row)"
            >{{ funcView.receive_refund_check_collection }}</el-button>
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 查看退款信息 -->
    <refund-record-dialog
      v-if="dialogVisible5"
      :isReverse="true"
      :model="dialogModel5"
      @close="dialogVisible5 = false"
      type="receive"
    ></refund-record-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import refundRecordDialog from '../payRefund/children/refund_register_dialog.vue';
import commonMixin from '../mixins/commonMixin';

const isMock = false;

export default {
  name: 'receiveRefund',
  mixins: [resetFormSearchMixins, commonMixin],
  components: { refundRecordDialog },
  data() {
    return {
      provide: true,
      tableSelect: [],
      formSearch: {
        dataType: 1,
        billTradeState: [],
        search: '',
        bodyNum: '',
        billPaymentTime: '',
        orderState: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      dialogVisible5: false,
      dialogModel5: {},
      // 应收管理-确认收款
      dialogVisible3: false,
      dialogModel3: {},
    };
  },
  computed: {
    dataType() {
      const ret = [];
      // if (this.funcView.receive_deposit_list) {
      ret.push({
        label: this.$t('fms_receive_refund.ying_shou_tui_kuan'),
        langCode: '',
        value: 1,
      });
      // }
      // if (this.funcView.receive_deposit_returning_list) {
      ret.push({
        label: this.$t('fms_receive_refund.yi_shou_tui_kuan'),
        langCode: '',
        value: 2,
      });
      // }
      return ret;
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView(this.isPortal ? '/portal/deviceBill/receiveRefund' : '/receive/receiveRefund');
  },
  methods: {
    onTabChange() {
      this.formSearch.billTradeState = [];
      this.onPageChange({ page: 1 });
    },
    // 确认收款
    onToConfirm({ billData, resData }) {
      this.confirmCollection(billData, this.$t('fms_receive_refund.que_ren_shou_kuan'), resData);
    },
    getReqData() {
      const ret = {
        ...this.formSearch
      };
      if (!ret.billTradeState || !ret.billTradeState.length) {
        ret.billTradeState = this.formSearch.dataType === 2 ? [10] : [0, 1, 6];
      }

      return this.appendReqListData(ret, 'receive_refund');
    },
    // 获取表格数据
    getTableList: function () {
      const reqData = this.getReqData();
      this.$getJSON(apis.billRecevieRefund, reqData).then((res) => {
        this.tableList = this.formatList(res.data.list);
        this.totalRows = res.data.total;
      });
    },
    formatList(list) {
      list.forEach((item) => {
        if (isMock) {
          item.billId = '';
        }
      });
      return list;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 查看退款记录  显示条件  row.billId
    onCheckCollectionRecords(row) {
      const { billId } = row;
      if (!billId) {
        this.$message.error(
          this.$t('fms_receive_refund.sjycqsgjzd')
        );
        return;
      }
      this.dialogModel5.type = 'watch';
      this.dialogModel5.title = this.$t('fms_receive_refund.cktkxx'); // this.funcView.receive_refund_check_collection
      this.dialogModel5.row = row;
      this.dialogVisible5 = true;
    },
  },
};
</script>

<style lang="scss"></style>
